export default {
  training: {},
  ceo: {},
  trainingGuests: [],
  savedGuests: [],
  companyGuests: [],
  trainingCeo: {},
};
